import React, { useState, useEffect, useCallback, useRef } from "react";
import "./ProductCardSmall.scss";
import { useLocation, useHistory } from 'react-router-dom';
import request from "../../request";
import favoriteactive from "../../assets/images/card/favorite.svg";
import favoriteinactive from "../../assets/images/card/BlackFavourite.svg";
import snowImg from "../../assets/images/snow-img.svg";
import quotationImg from "../../assets/images/Quotation.png";
import chilledImg from "../../assets/images/Chilled.svg";
import ADDCART from "../../assets/images/card/ADDCART.svg"
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useStateValue } from '../../store/state';
import { useTranslation } from 'react-i18next';
import { browserName, browserVersion } from 'react-device-detect';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import PDPImageCarousel from "../PDPPage/ProductInfo/PDPImageCarousel/PDPImageCarousel";
import ProductDefaultImage_transparent from "../../assets/images/card/ProductDefaultImage_transparent.png";
import NoAddressModal from "../NoAddressModal/NoAddressModal";

function ProductCardSmall(props) {
  const { image, pack_size, name, sku, selling_unit_price, entity_id, selling_unit, quote, favourite, options, is_in_stock, url_key, order_taking, category_id, storage, temperature, moq } = props.data
  const { CDN_BASE_URL_FLAG, imageendpoint } = request
  const { setRefreshAPI, title, refreshAPI, page } = props
  const [currentID, setCurrentID] = useState(0)
  const { t } = useTranslation();
  const [{ cart, CATALOG_COUNTRY_FILTER_DATA, cartCount }, dispatch] = useStateValue();
  const isNewArrivalProduct = title === "New Arrivals || New Arrival" ? true : false
  const [isFavorite, setIsFavorite] = useState(favourite == "1" ? true : false);
  const location = useLocation();
  const isPDPPage = location.pathname.startsWith("/pdp/");
  const history = useHistory();
  const pendingCartItem = localStorage.getItem("pendingAddToCart");
  const pendingFavItem = localStorage.getItem("pendingAddToFavorite");
  const token = localStorage.getItem("token");
  const hasRun = useRef(false);
  const [showNoAddressModal, setShowNoAddressModal] = useState(false);

  useEffect(() => {
    if (hasRun.current) return; // Prevent running again
    if (token && pendingCartItem) {
      const { entity_id: pendingID } = JSON.parse(pendingCartItem);
      if (pendingID === entity_id) {
        // Only add if this product card matches the pending product
        hasRun.current = true; // Mark as done
        addtocart(); // Your existing addtocart function
        localStorage.removeItem("pendingAddToCart");
        history.push("/cart");
      }
    }
  }, [pendingCartItem]);

  // Before login after login add to fav logic here
  useEffect(() => {
    if (hasRun.current) return; // Prevent running again
    if (token && pendingFavItem) {
      const { entity_id: pendingID } = JSON.parse(pendingFavItem);
      if (pendingID === entity_id) {
        // Only add if this product card matches the pending product
        hasRun.current = true; // Mark as done
        addToFav(); // Your existing addToFav function
        localStorage.removeItem("pendingAddToFavorite");
        history.push("/myfavourite");
      }
    }
  }, [pendingFavItem]);


  const createlog = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      await axios({
        method: "post",
        url: request.newlog,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            company_id: localStorage.getItem("companyid"),
            remote_ip: res.data.IPv4,
            user_agent: `${browserName} Version:${browserVersion}`,
            action: `${JSON.parse(localStorage.getItem("userdata")).firstname
              } added 1 ${name} in the cart`,
            action_type: "save",
            functioncall_url: "user/save/",
          },
        },
      });
      // Removed the notification creation API call
    } catch (e) {
      console.log(e)
    }
  };
  const animateCartIcon = useCallback(() => {
    const cartIcon = document.getElementById('cart-icon');
    if (cartIcon) {
      cartIcon.classList.remove('animate'); // Remove first to ensure we can add again
      void cartIcon.offsetWidth; // Force reflow
      cartIcon.classList.add('animate');
    }
  }, []);

  const flyToCart = (startElement, endElement) => {
    if (!startElement || !endElement) {
      return;
    }
    const startRect = startElement.getBoundingClientRect();
    const endRect = endElement.getBoundingClientRect();

    const flyingItem = document.createElement('div');
    flyingItem.className = 'flying-item';

    Object.assign(flyingItem.style, {
      position: 'fixed',
      left: `${startRect.left}px`,
      top: `${startRect.top}px`,
      width: '36px',
      height: '36px',
      backgroundImage: `url(${ADDCART})`,
      backgroundSize: 'contain',
      zIndex: '9999',
      transition: 'all 2s cubic-bezier(0.4, 0, 0.2, 1)', // Slower 2s animation
      pointerEvents: 'none',
      backgroundColor: 'white',
      borderRadius: '50%',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    });

    document.body.appendChild(flyingItem);

    requestAnimationFrame(() => {
      flyingItem.style.transition = 'all 0.8s cubic-bezier(0.2, 0.6, 0.4, 1)';
      flyingItem.style.transform = `translate(${endRect.left - startRect.left}px, ${endRect.top - startRect.top}px) scale(0.3)`;
      flyingItem.style.opacity = '0';
    });

    flyingItem.addEventListener('transitionend', () => {
      flyingItem.remove();
      endElement.classList.add('animate');
      setTimeout(() => endElement.classList.remove('animate'), 500);
    });
  };
  const addtocart = async () => {
    if (is_in_stock === "0") return;

    const productElement = document.getElementById(`addcart-icon-${entity_id}`);
    const cartIcon = document.getElementById('cart-icon');
    let addressdata = [];
    if (productElement && cartIcon) {
      flyToCart(productElement, cartIcon);
    }
    try {

      // Get address data
      const address = await axios({
        method: "get",
        url: `${request.getbranch}/${localStorage.getItem("userid")}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // For social login user her check delivery address there or not, if not user need to add deliveryaddress
      if (address?.data?.length === 0) {
        setShowNoAddressModal(true);
        return;
      }
      // addlist.current = address.data;
      addressdata.push(address.data);
    } catch (e) {
      console.log("catch error : ", e)
      // toast.error(e.response?.data?.message);
    }
    let defaultaddress;
    addressdata[0]?.find((data) => {
      if (data?.chk_default == "Y") {
        defaultaddress = data;
      }
    });
    const findsku = cart.find((c) => c.sku === sku);

    let date;
    try {
      const datechk = await axios({
        method: "get",
        url: `${request.erprequest}/products/${sku}/delivery-date`,
        headers: {
          token: `Bearer ${localStorage.getItem("erpToken")}`,
        },
      });
      date = datechk.data.data[0].DELIVER_DATE.slice(parseInt(defaultaddress?.leadtime_days));
    } catch (e) {
      console.log("catch error : ", e)
    }
    if (date) {
      try {
        const cartdata = await axios({
          method: "post",
          url: request.cartadd,
          data: {
            cartItem: {
              sku: sku,
              quote_id: localStorage.getItem("cartid"),
              qty: moq ? parseInt(moq) : 1,
              price: options[0]?.price,
              extension_attributes: {
                unit: options[0]?.order_type,
              },
            },
            splitorder: {
              company_id: localStorage.getItem("companyid"),
              customer_id: localStorage.getItem("userid"),
              branch_id: defaultaddress?.address_id,
              product_id: entity_id,
              item_id: findsku?.item_id ? findsku?.item_id : 0,
              name: name,
              sku: sku,
              delivery_date: moment(date[0]?.DD).format("YYYY-MM-DD"),
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (cartdata.data[0].errors == false) {
          toast.info("The Requested qty is not available");
        }
        if (cartdata.data[0].success) {
          dispatch({
            type: "SET_CART",
            payload: cartdata.data[0].items || []
          });

          await createlog();
        }
        dispatch({
          type: "CART_STATUS",
        });
      } catch (e) {
        console.log("catch error : ", e)
      }
    }
  };

  // FAVOURITES HANDLER
  const addToFavHandler = async () => {
    if (isFavorite) {
      await deletefromFav();
    } else {
      await addToFav();
    }
    setIsFavorite(!isFavorite); // Toggle favorite state
    setRefreshAPI(!refreshAPI);
  };

  // _ADD TO FAVOURITES API
  const addToFav = async () => {
    try {
      const viewPost = await axios({
        method: "post",
        url: request.addFav,
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            product_id: entity_id,
            company_id: localStorage.getItem("companyid"),
          },
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch({
        type: "GENERAL__TRIGGER",
      });
      toast.success(`${name} ${t("FAVADDED")}`);
      setIsFavorite(true);
    } catch (e) {
      console.log("catch error : ", e)
    }
  };

  // DELETE FROM FAVOURITES API
  const deletefromFav = async () => {
    try {
      await axios({
        method: "delete",
        url: `${request.deletefav}/${entity_id}/${localStorage.getItem("userid")}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch({
        type: "GENERAL__TRIGGER",
      });
      toast.success(`${name} ${t("FAVREMOVED")}`);
      setIsFavorite(false);
    } catch (e) {
      console.log(e);
    }
  };

  function formatToCurrency(price) {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const getCountryFlagUrl = () => {
    if (props.data.country_of_manufacture) {
      return `${CDN_BASE_URL_FLAG}${props.data.country_of_manufacture.toLowerCase()}.svg`;
    }
    return null;
  };

  // Function to format pack size based on storeid
  function formatPackSize(packSize) {
    // If storeid is 1, display the pack size in English
    if (localStorage.getItem("storeid") === "1") { // Note: localStorage returns string
      return packSize; // Return as is for English display
    } else {
      // Otherwise, format for Thai
      if (typeof packSize !== 'string') return packSize;
      if (packSize.startsWith('.')) packSize = '0' + packSize;
      return updatedData(packSize); // Replace units with localized ones
    }
  }



  const isFrozen = () => {
    return (storage || '').startsWith('FROZEN')
  }

  const isChilled = () => {
    return (storage || '').startsWith('CHILLED')
  }

  const replacements = {
    "KG": t('KG'),
    "PC": t('PC'),
    "PK": t('PK'),
    "BG": t("BG"),
    "BK": t("BK"),
    "BT": t("BT"),
    "BX": t("BX"),
    "CA": t("CA"),
    "CP": t("CP"),
    "CT": t("CT"),
    "DR": t("DR"),
    "DZ": t("DZ"),
    "GL": t("GL"),
    "GM": t("GM"),
    "JR": t("JR"),
    "LT": t("LT"),
    "ML": t("ML"),
    "OZ": t("OZ"),
    "PA": t("PA"),
    "SC": t("SC"),
    "SH": t("SH"),
    "TI": t("TI"),
    "TR": t("TR"),
    "TU": t("TU"),
    "TY": t("TY"),
  };

  const updatedData = (item) => {
    if (typeof item !== 'string') {
      console.error('Expected a string for item, but got:', item);
      return item;
    }

    let updatedItem = item;
    Object.keys(replacements).forEach(key => {
      updatedItem = updatedItem.replace(new RegExp(key, 'g'), replacements[key]);
    });

    return updatedItem;
  };
  const getImageUrl = (img) => {
    if (!img) return "";
    if (img.startsWith("http") || img.startsWith("//")) {
      return img;
    }
    return `${request.image}media/catalog/product${img}`;
  };

  const finalImageSrc = getImageUrl(image);

  // Add state to track the full image URL
  const fullImageUrl = (image && (image.startsWith("http") || image.startsWith("//"))) 
    ? image 
    : `${imageendpoint}media/catalog/product${image}`;

  return (
    <div
      className={`PC__small HOVERED__CONTENT${currentID === entity_id ? "" : ''} ${page === "pdpmobile" ? "pdpmobile" : ''}`}
      onMouseEnter={() => setCurrentID(entity_id)}
      onMouseLeave={() => setCurrentID(0)}
    >
      {currentID === entity_id &&
        <img className='HOVERED__CARD__FAV'
          src={isFavorite ? favoriteactive : favoriteinactive}
          onClick={() => {
            const token = localStorage.getItem("token");
            if (!token) {
              localStorage.setItem("pendingAddToFavorite", JSON.stringify({ entity_id }));
              localStorage.setItem("redirectAfterLogin", window.location.pathname);
              history.replace("/login", { from: location.pathname });
            } else {
              addToFavHandler();
            }
          }}
          alt=""
        />
      }
      {/* {order_taking == "N" && } */}
      {order_taking == "Y" && currentID === entity_id ?
        <Link
          className='ORDERTAKING__CALENDAR HOVERED__CARD__ADDCART'
          to={{ pathname: `/pdp/${!quote ? "catalog" : "product"}/${order_taking == "Y" ? "ordertaking" : "stock"}/${category_id}/${entity_id}/${url_key}`, state: { fullImageUrl } }}
          state={{ fullImageUrl }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" >
            <g clip-path="url(#clip0_1972_38528)">
              <rect width="28" height="28" rx="14" fill="#37BFA7" />
              <path d="M10.1111 13.2H11.6667V14.8H10.1111V13.2ZM21 9.2V20.4C21 21.28 20.3 22 19.4444 22H8.55556C7.69222 22 7 21.28 7 20.4L7.00778 9.2C7.00778 8.32 7.69222 7.6 8.55556 7.6H9.33333V6H10.8889V7.6H17.1111V6H18.6667V7.6H19.4444C20.3 7.6 21 8.32 21 9.2ZM8.55556 10.8H19.4444V9.2H8.55556V10.8ZM19.4444 20.4V12.4H8.55556V20.4H19.4444ZM16.3333 14.8H17.8889V13.2H16.3333V14.8ZM13.2222 14.8H14.7778V13.2H13.2222V14.8Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1972_38528">
                <rect width="28" height="28" rx="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
        : currentID === entity_id && <img onClick={() => {
          const token = localStorage.getItem("token");
          if (!token) {
            // Save the product info to add after login
            localStorage.setItem("pendingAddToCart", JSON.stringify({ entity_id }));
            localStorage.setItem("redirectAfterLogin", window.location.pathname);
            history.replace("/login", { from: location.pathname });
          } else {
            addtocart(); // Already logged in, add to cart directly
          }
        }}
          id={`addcart-icon-${entity_id}`}
          className={`HOVERED__CARD__ADDCART ${is_in_stock == "0" && "CART__NOSTOCK"}`}
          src={ADDCART}
          alt="Add to cart"
          style={{
            position: "absolute",
            bottom: 10,
            right: 10,
            width: 36,
            height: 36,
            cursor: "pointer",
            background: "#fff",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"

          }}
        />
      }
      <Link
        to={{ pathname: `/pdp/${!quote ? "catalog" : "product"}/${order_taking == "Y" ? "ordertaking" : "stock"}/${category_id}/${entity_id}/${url_key}`, state: { fullImageUrl } }}
        prefetch>
        <img id={`product-img-${entity_id}`} src={finalImageSrc} alt=""
          className={`${currentID === entity_id && "HOVERED__IMG"}`}
          onError={(e) => {
            e.target.onerror = null; // Prevent infinite loop in case fallback also fails
            e.target.src = ProductDefaultImage_transparent // Set your fallback image path here
          }}
        />
      </Link>
      <div className='product_btn_wrapper'>
        {order_taking === "Y" && <>
          <span className='CARD__PREORDER'>Pre-Order</span>
        </>}
        {isFrozen() && <img src={snowImg} className="snow-img" />}
        {isChilled() && <img src={chilledImg} className="snow-img" />}
        {props.data.country_of_manufacture && (
          <div className="country-info">
            <img
              src={getCountryFlagUrl()}
              className="country-flag"
              alt={props.data.country_of_manufacture}
            />
            <span className="country-name">{props.data.country_of_manufacture}</span>
          </div>
        )}

      </div>
      <div className={`${quote ? "QUOTE__PRODUCT" : "CATALOG__PRODUCT"}`}>
        {/* NOT__HOVERED */}
        <span className={`${currentID === entity_id ? "HOVERED__NAME" : "HOVERED__NAME"}`} title={name}>{name}</span>
        <div className='PC__SKU'>{sku}</div>
        <div className='PC__PACKSIZE'>
          {t("SIZE")} {formatPackSize(pack_size)}
        </div>
        <span className='quation_price'>
          {quote && <img src={quotationImg} alt="" className='QUOTES' />}
          <span className={`${currentID === entity_id ? "HOVERED__PRICE" : "HOVERED__PRICE"}`}>
            ฿ {selling_unit_price != undefined ? formatToCurrency(parseFloat(selling_unit_price).toFixed(2)) : 0}/{updatedData(selling_unit || "")}
          </span>
        </span>
      </div>
      {isPDPPage && page !== "pdpPage" && (
        <PDPImageCarousel
          fullImageUrl={fullImageUrl}
          images={props.data.images}
        />
      )}

      {/* Add this at the end */}
      <NoAddressModal
        open={showNoAddressModal}
        onClose={() => setShowNoAddressModal(false)}
        t={t}
      />
    </div>
  )
}

export default ProductCardSmall